export default {
	login: {
		salesBackend: "OMELINK Sales Backend Login",
		account: "Account",
		password: "Password",
		login: "Login",
		loggingIn: "Logging in...",
		pleaseEnter: "Please enter",
		userName: "Username",
		loginSuccessful: "Login successful",
		loginFailed: "Login failed, please check your account and password",
		usingOa: "Log in using your OA account",
		usingSjfood: "Log in using your HiFood account",
		and: "and",
	},
	index: {
		customerSettings: "Customer Settings",
		personalInformation: "Personal Information",
		logOut: "Log Out",
		selectLanguage: "Select Language",
		confirmExit: "Confirm exit?",
		hint: "Hint",
		productSettings: "Product Settings",
		syncSettings: "Sync Settings",
		customerBinding: "Customer Binding",
	},
	personal: {
		avatar: "Avatar",
		nickName: "Nickname",
	},
	operator: {
		addTo: "Add to",
		authorizer: "Authorizer",
		permissions: "Permissions",
		startingTime: "Starting Time",
		endTime: "End Time",
		revise: "Revise",
		delete: "Delete",
		viewPermissions: "View Permissions, Send Permissions",
	},
	customer: {
		customerCode: "Customer Code",
		customerName: "Customer Name",
		warehouse: "Warehouse",
		customerBindingQuantity: "Customer Binding Quantity",
		maintenanceQuantity: "Material Change Maintenance Quantity",
		operate: "Operate",
		customerBinding: "Customer Binding",
		productSettings: "Product Settings",
		batchOpertion: "Batch Maintenance",
		selectCustomer: "Select Customer",
		importItem: "Import Item",
		batchImportItem: "Batch Import Item",
		successfully: "Completed",
		previousStep: "Previous Step",
		nextStep: "Next Step",
		selectFile: "Select File",
		templateDownload: "Template Download",
		noFileSelected: "No file selected",
		downloadingTemplate: "Template downloaded successfully",
		operationSuccess: "Batch maintenance successful",
		aTotalOf: "A total of",
		errorTips: "items have ID errors detected by the system, import failed! Please check and try again.",
		importSuccessfully: "Import successful",
	},
	customerProduct: {
		myClient: "My Client",
		productSettings: "Product Settings",
		specification: "Specification",
		editedSuccessfully: "Edited successfully!",
	},
	customerProductLastest: {
		myClient: "My Client",
		productSettings: "Product Settings",
		syncSettings: "Sync Settings",
		changeUpdates: "Check Product Change Updates",
		old: "Old",
		new: "New",
		state: "State",
		waitingForConfirmation: "Waiting for confirmation",
		applied: "Applied",
		notApplied: "Not applied",
		operate: "Operate",
		newAdditions: "New Additions",
		renew: "Renew",
		time: "Time",
		SALESConfirmed: "SALES Confirmed",
		application: "Application",
		notApplied: "Not applied",
		successfulOperation: "Operation successful!",
	},
	customerPhone: {
		myClient: "My Client",
		customerBinding: "Customer Binding",
		addBinding: "Add Binding",
		noData: "No data, please add",
		telephoneNumber: "Telephone Number",
		remarkName: "Remark Name",
		memorandum: "Memorandum",
		smsDisable: "Disable SMS",
		operate: "Operate",
		edit: "Edit",
		unbind: "Unbind",
		CRMContact: "Select CRM Contact",
		enterANote: "Enter a note",
		editBinding: "Edit Binding",
		correctPhoneNumber: "Please enter correct format of telephone number",
		ContentIsTooLong: "Please enter memo",
		bindingSuccessfully: "Binding added successfully!",
		errorMessage: "Fill in information has errors!",
		successfulOperation: "Operation successful!",
		setupSuccessful: "Setup successful!",
		closedSuccessfully: "Closed successful!",
		unbindHint: "Are you sure to unbind?",
		hint: "Hint",
		UnbindingSuccessful: "Unbinding successful!",
		numberIdentityNote: "Number, Identity, Note",
		selectIdentityNote: "Select Identity Note",
		customRemarks: "Custom Number Identity Note",
		pleaseEnterCustomRemarks: "Please enter custom number identity note",
		manager: "Manager",
		boss: "Boss",
		headChef: "Head Chef",
		accountant: "Accountant",
		custom: "Custom",
		phoneEditDelateGuid: "Unable to operate on contacts sourced from CRM. Please perform the operation in CRM.",
        billManagement: "Bill Management",
        add: "Add",
	},
	productSpecification: {
		addTo: "Add to",
		nameSearch: "Enter specification name for search",
		specificationName: "Specification Name",
		operate: "Operate",
		edit: "Edit",
		editSpecifications: "Edit Specification",
		attributes: "Attributes",
		addAttributes: "Please add attributes",
		name: "Name",
		optionName: "Enter option name",
		enterSpecificationName: "Please enter specification name!",
		addOptions: "Please add options!",
		editedSuccessfully: "Edited successfully!",
		errorMessage: "Fill in information has errors!",
		enterAttributeName: "Enter attribute name",
		sureDelete: "Are you sure to delete?",
		hint: "Hint",
		successfullyDeleted: "Successfully deleted!",
		cannotSortWhenSearching: "Cannot sort when searching",
		sortingSaveFail: "Sorting save failed",
		sortingSaveSuccess: "Sorting save success",
	},
	productHistory: {
		materialChange: "Material Change Maintenance",
		aliasSearch: "Enter product name or alias for search",
		noData: "No data",
		productName: "Product Name",
		productAlias: "Product Alias",
		category: "Category",
		state: "State",
		enable: "Enable",
		disable: "Disable",
		operate: "Operate",
		edit: "Edit",
		codingImportGoods: "Import products by customer code",
		importProducts: "Import products",
		enterCustomerCode: "Enter customer code",
		selectProduct: "Select product",
		finish: "Finish",
		customerCode: "Customer Code",
		nextStep: "Next step",
		cancelSelection: "cancel selection",
		previous: "Previous",
		import: "Import",
		aTotalOf: "A total of ",
		productImportSuccess: "products were imported successfully",
		productImportFailure: "products were detected by the system as duplicates and the import failed! Please check before importing.",
		pleaseEnterCustomerCode: "Please enter customer code!",
		messageInformationCorrectly: "Please fill in the information correctly!",
		pleaseSelectProduct: "Please select the product information you want to import!",
	},
	productEdit: {
		editProductInformation: "Edit Product Information",
		basicInformation: "Basic Information",
		productName: "Product Name",
		productAlias: "Product Alias",
		category: "Category",
		state: "State",
		enable: "Enable",
		disable: "Disable",
		specificationInformation: "Specification Information",
		selectSpecifications: "Select Specifications",
		deleteSpecification: "Delete Specification",
		enterSpecificationName: "Enter specification name",
		addSpecs: "Add specifications",
		pleaseChoose: "Please choose",
		attributes: "Attributes",
	},
	productAll: {
		aliasSearch: "Enter product name or alias for search",
		noData: "No data",
		productName: "Product Name",
		productAlias: "Product Alias",
		category: "Category",
		state: "State",
		enable: "Enable",
		disable: "Disable",
		operate: "Operate",
		edit: "Edit",
		insert: "Insert",
		insertingSuccessfully: "Inserting history successfully!",
	},
	avatar: {
		setAvatar: "Set Avatar",
		preview: "Preview",
		changePicture: "Change Picture",
		enlarge: "Enlarge",
		zoomOut: "Zoom out",
		rotateLeft: "Rotate left",
		rotateRight: "Rotate right",
		upload: "Upload",
		errorGetAvatar: "Failed to get avatar, please try again later",
		sizeCannotExceed: "Uploaded avatar image size cannot exceed 2MB!",
		selectPicture: "Select picture",
		setupSuccessful: "Setup successful",
		uploadFailed: "Upload failed, please try again later",
	},
	addSpecification: {
		addSpecs: "Add specifications",
		specificationName: "Specification Name",
		attributes: "Attributes",
		addAttributes: "Please add attributes",
		addTo: "Add to",
		name: "Name",
		operate: "Operate",
		delete: "Delete",
		addProperties: "Add properties",
		enterAttributeName: "Enter attribute name",
		enterSpecificationName: "Enter specification name!",
		addOptions: "Add options",
		addedSuccessfully: "Added successfully!",
		errorMessage: "Fill in information has errors!",
	},
	chatEmojiPicker: {
		recent: "Recent",
		people: "People",
		nature: "Nature",
		foods: "Foods",
		activity: "Activity",
		places: "Places",
		objects: "Objects",
		symbols: "Symbols",
		flags: "Flags",
	},
	chatHistoryMessage: {
		viewContext: "View Context",
		copy: "Copy",
		save: "Save",
		copiedToClipboard: "Copied to clipboard",
		copyFailed: "Copy failed",
		errorTextMessage: "Supports text message copy only temporarily",
		errorMessage: "Supports voice message save only temporarily",
	},
	chatHistory: {
		enterChatContent: "Enter chat content",
		back: "Back",
	},
	chatMessageCheckDetails: {
		serialNumber: "Serial Number",
		amount: "Amount",
		uploadDate: "Upload Date",
		frontPicture: "Front Picture of Check",
		reversePicture: "Reverse Picture of Check",
		supplier: "Supplier",
		userAmount: "User Input Amount",
		checkStatus: "Check Status",
	},
	chatMessageCheck: {
		checkUploadReminder: "Check Upload Reminder",
		checkCheckUpload: "Check Check Upload",
		checkDetails: "Check Details",
	},
	chatMessageNonsupport: {
		versionIsTooLow: "Your version is too low to view this content",
	},
	chatMessageOrder: {
		orderDetails: "Order Details",
		order: "Order",
		deliveryDate: "Delivery date",
		productsOrdered: "Products ordered",
		productsInclude: "Products include",
		viewOrder: "View order",
	},
	chatMessageReadStatus: {
		haveRead: "Have Read",
		unread: "Unread",
		readingStatus: "Reading Status",
	},
	chatMessageStatus: {
		resendThisMessage: "Resend this message?",
		hint: "Hint",
	},
	chatMessageText: {
		translateText: "Translate Text",
	},
	chatMessageVoice: {
		voiceIsCorrupted: "Voice is corrupted",
	},
	chatMessages: {
		retractedMessage: "You retracted a message",
		copy: "Copy",
		save: "Save",
		recall: "Recall",
		concealTranslated: "Conceal Translated",
		translated: "Translated",
		copiedToClipboard: "Copied to clipboard",
		copyFailed: "Copy failed",
		supportsTextMessages: "Supports text message copy only temporarily",
		supportsTextVoice: "Supports voice message save only temporarily",
		supportsTexttranslated: "Supports text translation only temporarily",
	},
	chatPicturePaster: {
		sendThisImage: "Send this image?",
		send: "Send",
	},
	chatRecorder: {
		recording: "Recording",
		stop: "Stop",
		send: "Send",
		recordingFailed: "Recording failed",
		timeShort: "Speaking time is too short",
		timeLong: "Speaking time is too long",
		microphonePermissionDenied: "Recording failed, please allow access to the microphone.",
	},
	contactList: {
		remarkName: "Remark Name:",
	},
	contacts: {
		contactPerson: "Contact Person",
	},
	conversationList: {
		recentChat: "Recent Chat",
		remarkName: "Remark Name:",
		cancelStick: "Cancel Stick",
		haveRead: "Have Read",
		unread: "Unread",
		stick: "Stick",
		pinnedSuccessfully: "Pinned successfully!",
		unpinnedSuccessfully: "Unpinned successfully!",
	},
	detailContact: {
		chatInformation: "Chat Information",
		METISusageCount: "METIS Usage Count:",
		leftOver: "Left over",
		strip: "Strip",
		nickName: "Nickname",
		remarkName: "Remark Name",
		revise: "Revise",
		associatedCustomers: "Associated Customers",
		none: "None",
		smartResponse: "METIS Smart Response Customer Service",
		open: "Open",
		close: "Close",
		automaticTranslation: "Automatic Translation",
		setupSuccessful: "Setup successful!",
		enterRemarks: "Enter remarks",
		hint: "Hint",
		yes: "YES",
		no: "NO",
		phoneNumber: "Phone number",
		openTip1: "PST 13:30 - next day PST 01:00",
		openTip2: "During this period, if the customer's question intent is recognized as a known issue, METIS will respond normally.",
		openTip3: "During this period, if the customer's question intent is recognized as an unknown issue, METIS will not respond.",
		userDoesNotBelong: "The current user is not your contact",
	},
	detailGroup: {
		groupInformation: "Group Information",
		groupChatName: "Group Chat Name:",
		modifyGroupName: "Modify Group Name",
		addMember: "Add Member",
		noData: "No data, please add",
		avatar: "Avatar",
		nickName: "Nickname",
		groupNotes: "Group Notes",
		operate: "Operate",
		editorNotes: "Edit Notes",
		removeMember: "Remove Member",
		userDoesNotBelong: "Current user does not belong to this group!",
		enterTheCommentName: "Enter the member's remark name",
		hint: "Hint",
		selectMembers: "Select members",
		pleaseEnterTheGroupChatName: "Please enter the group chat name",
		groupNameHasNotChanged: "Group name has not changed!",
		groupNameCannotBeEmpty: "Group name cannot be empty!",
		confirmToRemoveMember: "Confirm to remove member?",
	},
	groupList: {
		groupChat: "Group Chat",
		createGroupChat: "Create Group Chat",
		groupName: "Group Name:",
	},
	selectMember: {
		selectMembers: "Select Members",
		chosen: "Chosen:",
		contactPerson: "Contact Person",
		salesperson: "Salesperson",
		groupChat: "'s Group Chat",
		atLeast: "At least 3 members are required for group chat",
	},
	chat: {
		realTimeServer: "Real-time server connection failed, connecting...",
		enterSearchContent: "Enter search content",
		recentChat: "Recent Chat",
		addressBook: "Contact",
		groupChat: "Group Chat",
		chatRecord: "Chat Record",
		selectLanguage: "Select Language",
		ctrlEnter: "Press Ctrl + Enter to send message",
		commandEnter: "Press Command + Enter to send message",
		enter: "Press Enter to send message",
		translateContent: "Translate Content",
		send: "Send",
		imageUploadFailed: "Image upload failed, please try again",
		onlyWithdrawMessages: "You can only withdraw your own messages",
		fileError: "Unable to read video file information!",
		loadFailed: "Load failed, click to retry",
		loading: "Loading...",
		fileErrorTip: "Failed to send. File format supports images or MP4, file size does not exceed 300MB, and file duration does not exceed 30 minutes.",
		aFile: "a file",
		errorTip: "File upload failed, cannot resend, please reselect the file to upload.",
	},
	messageJS: {
		voice: "[Voice]",
		picture: "[Picture]",
	},
	storeIndexJS: {
		have: "Have",
		unreadMessages: "unread messages",
		haveNewMessage: "You have a new message",
	},
	apiJS: {
		loginHasExpired: "Login has expired, do you want to log in again?",
		hint: "Hint",
		unknownMistake: "Unknown mistake",
	},
	router: {
		login: "Login",
		customerCommunication: "Customer Communication",
		setup: "Setup",
		myClient: "My Client",
		customerBinding: "Customer Binding",
		productSettings: "Product Settings",
		syncSettings: "Sync Settings",
		personalInformation: "Personal Information",
		authorizationSettings: "Authorization Settings",
		messageSending: "Message Sending",
		aiEmail: "AI EMAIL设置",
		openClawManagement: "Digital Employee Management",
		omelinkUserServiceMaintenance: "OMELINK User Service Maintenance",
	},
	dateJS: {
		today: "Today",
	},
	common: {
		cancel: "Cancel",
		confirm: "Confirm",
		sure: "Sure",
		delete: "Delete",
		options: "Options",
		option: "Option",
		history: "History",
		all: "All",
		setup: "Setup",
	},
	chatMessageOrderDetails: {
		supplier: "Supplier",
		orderBy: "Order by",
		billTo: "Bill to",
		shipTo: "Ship to",
		deliveryDate: "Delivery Date",
		comment: "Comment",
		ordered: "Ordered",
		include: "Include",
		orderDetails: "Order Details",
	},
	generalization: {
		listTitle: "Promotion List",
		searchPlaceholder: "Search",
		checkOut: "View Details",
		sendAgain: "Resend",
		send: "Send Now",
		detailTitle: "Promotion Details",
		isSendMessage: "Send the message to",
	},
	messageSending: {
		title: "Customers not registered with OMELINK",
		customerName: "Guest Name",
		customerPhone: "Guest Phone",
		associatedRestaurantId: "Associated Restaurant ID",
		restaurantName: "Restaurant Name",
		operate: "Operation",
		historyRecord: "History Record",
		sendMessage: "Send SMS",
		cancel: "Cancel",
		confirm: "Confirm Sending",
		restaurantId: "Restaurant ID",
		close: "Close",
		orderId: "Order ID",
		snedText: "Sent Content",
		sendTime: "Send Time",
		sendSuccess: "Send Successful",
		isCheckedDocument: "View Document?",
		isDownLoad: "Download OMELINK?",
		sendDocument: "Send Document",
		true: "Yes",
		false: "No",
		check: "View",
	},
	aiEmail: {
		account: "Email Account",
		accountDescription: "Configure the mailbox used to receive and process AI order emails.",
		configureAccount: "Configure Email",
		editAccount: "Edit Email",
		emailAddress: "Email Address",
		emailPassword: "Email Password",
		passwordSetHint: "A password is already configured. Leave this blank to keep it unchanged.",
		accountEnabled: "Enable email processing",
		enabled: "Enabled",
		disabled: "Disabled",
		syncError: "Sync Error",
		latestSync: "Last Synced",
		noSyncTime: "Not available",
		accountEmpty: "No email account has been configured. Save an email address and password to begin.",
		emailDisabledNotice: "This email account is disabled. Emails will not be synchronized or processed, but contacts can still be maintained.",
		contacts: "Email Contacts",
		contactsDescription: "Only order emails from configured contacts will be processed by AI.",
		addContact: "Add Contact",
		editContact: "Edit Contact",
		guestEmail: "Customer Email",
		processingMode: "Processing Mode",
		automatic: "Automatic",
		semiAutomatic: "Semi-automatic",
		automaticDescription: "AI replies to the customer in English and places the order when the information is complete.",
		semiAutomaticDescription: "AI silently recognizes order intent and places the order without replying when the information is complete.",
		associatedCustomers: "Associated Customers",
		updatedAt: "Updated At",
		actions: "Actions",
		edit: "Edit",
		delete: "Delete",
		customerPlaceholder: "Select customers",
		noCustomers: "No Customer is available for the current salesperson.",
		loadingAccount: "Loading email settings...",
		loadingContacts: "Loading contacts...",
		validatingConnection: "Verifying email connection...",
		save: "Save",
		accountSaveSuccess: "Email settings saved.",
		statusUpdateSuccess: "Email status updated.",
		contactCreateSuccess: "Contact created.",
		contactUpdateSuccess: "Contact updated.",
		contactDeleteSuccess: "Contact deleted.",
		validationEmail: "Enter a valid email address.",
		validationPassword: "An email password is required the first time you save this account.",
		validationMode: "Select a processing mode.",
		validationCustomers: "Select at least one Customer.",
		confirmDelete: "Confirm Deletion",
		deleteContactMessage: "After deletion, the system will no longer process new emails from {email}. Delete this contact?",
	},
	serviceMaintenance: {
		userList: "User List",
		serviceProviderList: "Service Provider List",
		customerName: "Customer Name",
		customerPhone: "Customer Phone Number",
		associatedRestaurantId: "Associated Restaurant ID",
		restaurantName: "Restaurant Name",
		operate: "Actions",
		serviceMaintenance: "Service Provider Management",
		batchMaintenance: "Batch Service Provider Management",
		sort: "Sequence Number",
		applicationName: "Application Name",
		type: "Category",
		status: "Status",
		selectUsers: "Select Users",
		selectServiceProvider: "Select Service Provider(s)",
		complete: "Complete",
		nextStep: "Next Step",
		previous: "Previous Step",
		selectServiceProviderTip: "Select the service provider(s) to be displayed (unselected ones will be set to hidden/blocked)",
		batchMaintenanceComplete: "Batch Maintenance Completed",
		latestShelvesTime: "Latest Shelving Time",
		introduction: "Business Introduction",
		businessName: "Business Name",
		show: "Show / Display",
		hide: "Hide / Block",
		soft: "Software",
		service: "Service",
		successfulOperation: "Operation successful!",
	},
	openClawManagement: {
		guestName: "Guest Name",
		guestPhoneNumber: "Guest Phone Number",
		associatedRestaurantId: "Associated Restaurant ID",
		restaurantName: "Restaurant Name",
		status: "Digital Employee Status",
		operate: "Actions",
		show: "Show",
		hide: "Hide",
		noData: "No data",
		loading: "Loading...",
		updateSuccess: "Operation successful!",
	},
};
